export default "__VITE_ASSET__BqUCu6La__"